import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = { seriesData: Array, title: String };

  initialize() {
    this.renderChart();

    // document.onreadystatechange = () => {
    //   if (document.readyState === "complete") {
    //     console.log("Document is ready");
    //     this.renderChart();
    //   }
    // };
  }

  renderChart() {
    var options = {
      chart: {
        height: "100%",
        maxWidth: "100%",
        type: "area",
        fontFamily: "Inter, sans-serif",
        dropShadow: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ["#16a249", "#f59e0b", "#3b82f6", "#d946ef", "#f43f5e"],
      tooltip: {
        enabled: true,
        x: {
          show: false,
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.55,
          opacityTo: 0,
          shade: "#16a249",
          gradientToColors: ["#16a249"],
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 2,
      },
      grid: {
        show: false,
        strokeDashArray: 4,
        padding: {
          left: 2,
          right: 2,
          top: 0,
        },
      },
      series: this.seriesDataValue ?? [],
      xaxis: {
        type: "datetime",
      },
      yaxis: {
        title: {},
      },
    };

    var chart = new ApexCharts(this.element, options);
    chart.render();
  }
}
